/**
 * Carousel Navigation Component
 * Displays navigation buttons and investment cards in a carousel
 * Extracted from original lines 714-798
 */

import { FC, useState } from "react";
import { COLORS } from "../../../constants/colors";
import { BUTTON_STYLES } from "../StructureNote.constants";
import { InvestmentOpportunity } from "../StructureNote.types";
import InvestmentCard from "./InvestmentCard";

interface CarouselNavigationProps {
  visibleItems: InvestmentOpportunity[];
  canNavigateBackward: boolean;
  canNavigateForward: boolean;
  onNext: () => void;
  onPrev: () => void;
  selectedData: InvestmentOpportunity | null;
  onBoxSelect: (data: InvestmentOpportunity) => void;
  hideNoteSubscribe: boolean;
  showNavigation: boolean;
}

/**
 * Carousel with navigation buttons and investment cards
 * Original logic from lines 714-798
 */
const CarouselNavigation: FC<CarouselNavigationProps> = ({
  visibleItems,
  canNavigateBackward,
  canNavigateForward,
  onNext,
  onPrev,
  selectedData,
  onBoxSelect,
  hideNoteSubscribe,
  showNavigation,
}) => {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  const navigationButtonStyle = {
    ...BUTTON_STYLES.navigation,
    color: COLORS.agreementFont,
    marginRight: "10px",
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {/* Left navigation button (lines 721-737) */}
      {showNavigation && canNavigateBackward && (
        <button
          onClick={onPrev}
          style={{
            ...navigationButtonStyle,
            cursor: canNavigateBackward ? "pointer" : "not-allowed",
          }}
        >
          ←
        </button>
      )}

      {/* Investment cards container (lines 739-780) */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: showNavigation ? "100%" : "350px",
          justifyContent: "space-between",
        }}
      >
        {visibleItems.map((data: InvestmentOpportunity) => (
          <InvestmentCard
            key={data.id}
            data={data}
            isSelected={selectedData?.id === data.id}
            isHovered={hoveredId === data.id}
            onSelect={() => onBoxSelect(data)}
            onMouseEnter={() => setHoveredId(data.id)}
            onMouseLeave={() => setHoveredId(null)}
            disabled={hideNoteSubscribe}
          />
        ))}
      </div>

      {/* Right navigation button (lines 781-797) */}
      {showNavigation && canNavigateForward && (
        <button
          onClick={onNext}
          style={{
            ...navigationButtonStyle,
            cursor: canNavigateForward ? "pointer" : "not-allowed",
          }}
        >
          →
        </button>
      )}
    </div>
  );
};

export default CarouselNavigation;
